module.exports = require("live/components/codemirror/pipes");